// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1eSAq","title":"AfterBackImages_title__bL6oq","images":"AfterBackImages_images__3-BZa"};